























































































































































































































































import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import _ from 'lodash';
import moment from 'moment';

import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() refIds!: string[];

  @Prop() handleSelectOrder!: (...args: any[]) => any;

  curtime: number = moment().unix();

  dispatchType = 'bill/getBills';

  selectedRowKeys: any[] = [];

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '头像', scopedSlots: { customRender: 'avatar' } },
    { title: '会员名/昵称', scopedSlots: { customRender: 'username' } },
    { title: '订单类型', scopedSlots: { customRender: 'bill_cate' } },
    {
      title: '订场信息',
      customRender: (text: any, record: any, index: any) => this.renderOrderInfo(record),
    },
    { title: '下单时间', dataIndex: 'created_time' },

    { title: '支付方式', dataIndex: 'channel_name' },
    { title: '支付状态', scopedSlots: { customRender: 'is_pay' } },
    { title: '订单状态', scopedSlots: { customRender: 'bill_status' } },
  ];

  renderTime(dtime: string) {
    return moment(dtime).unix();
  }

  onSelectChange(selectedRowKeys: any, selectedRows: any) {
    // console.log(selectedRows);
    // console.log(selectedRowKeys);

    this.selectedRowKeys = selectedRowKeys;
  }

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        id: this.refIds.length > 0 ? this.refIds.join(',') : '',
      },
      false,
    );

    this.selectedRowKeys = this.refIds;
  }

  handleSubmit() {
    console.log(this.selectedRowKeys);
    this.handleSelectOrder(this.selectedRowKeys);
  }
}
